"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductClick = exports.Name = void 0;
const Name = exports.Name = 'product-click';
const ProductClick = exports.ProductClick = Name;
//# sourceMappingURL=index.js.map